import { useEffect, useState } from "react";
import { authParameters } from "utils/spotifyAPIUtils";

const useSpotifyAPI = () => {
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    fetch("https://accounts.spotify.com/api/token", authParameters)
      .then((result) => result.json())
      .then((data) => setAccessToken(data.access_token));
  }, []);

  return accessToken
};

export default useSpotifyAPI